import * as React from 'react';
import System from 'src/helper/system';
import { useBOMStore } from 'src/hooks/bom';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';

const BomDeleteProjectPopup = (props) => {
    const { data, SetStatus } = props
    const [{ }, { fetch_bom_project_detail_with_bom }, { delete_project }] = useBOMStore();
    const [{ }, { system_alert_indicator }, { }] = useDOMAttachToSystemStore();
    const { translation:t } = System;

    const onHide = () => {
        SetStatus(false)
    };
    
    const onDeleteProject = async () => {
        let projectId = data && data.projectId
        await delete_project({ projectId });
        onHide()
        await fetch_bom_project_detail_with_bom();
        system_alert_indicator({
            name: 'deleteBomProject',
            message: t('yourProjectHasBeenDeleted'),
            type: "success"
        })
    };

    return (
        <>
            <div className="avnet-modal modal-600">
                <div className="avnet-modal-inner">
                    <button type="button" className="close py-3" data-dismiss="modal"
                        onClick={() => {
                            onHide()
                        }}>×
                    </button>
                    <div className="modal-header border-0">
                        <h3 className="modal-title text-center m-auto" id="exampleModalLabel">{t('areYouSureYouWantToDeleteProject')}</h3>
                    </div>
                    <div className="modal-body">
                        <div className="mt-0 mb-5 text-center"><b className='font-14'>{t('thisWillDeleteAllTheBoms')}</b></div>
                    </div>
                    <div className="modal-footer d-flex justify-content-center">
                        <button type="button" className="bs5 btn btn-secondary w145"
                            onClick={() => {
                                onHide()
                            }}>{t('cancel')}
                        </button>
                        <button type="button" className="bs5 btn btn-primary  w145"
                            onClick={() => onDeleteProject()}>{t('deleteProject')}
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default BomDeleteProjectPopup;